import { executeRequest, getResponseBody } from './apiRequest';
import { ApiError } from './errors';
import type { ApiRequest, ApiResponse } from './types';

const handleResponse = (request: ApiRequest, response: Response) => {
  if (response.ok) {
    return getResponseBody(response);
  }

  throw new ApiError(request, response.statusText, response.status, response.headers);
};

type OcpsApiRequest = <TResponse>(request: ApiRequest) => Promise<ApiResponse<TResponse>>;
const ocpsApiRequest: OcpsApiRequest = async (request) => {
  try {
    const response = await executeRequest(request);
    const body = await handleResponse(request, response);

    return {
      body: {
        ...body,
        checkInTime: response.headers.get('checkin-interval'),
      },
      headers: response.headers,
    };
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }

    throw new ApiError(request, error as string);
  }
};

export default ocpsApiRequest;
